export default __webpack_public_path__ + "static/media/pushbullet.5e18722f.svg";